import { connect } from "vuex-connect";
// import log from 'loglevel';
import { SocialMediaImage } from "../../../components";

export default connect({
  stateToProps: {
    userCroppedSocialMediaImageUrl: state =>
      state.uploadContents.userCroppedSocialMediaImageUrl,
    isBusy: state => state.common.isBusy
  },
  gettersToProps: {
    originalSocialMediaImageUrl: "uploadContents/originalSocialMediaImageUrl",
    croppedSocialMediaImageUrl: "uploadContents/croppedSocialMediaImageUrl"
  },
  actionsToProps: {
    postSocialMediaImage: (dispatch, value) =>
      dispatch("uploadContents/postSocialMediaImage", value),
    deleteSocialMediaImage: (dispatch, value) =>
      dispatch("uploadContents/deleteSocialMediaImage", value)
  },
  mutationsToProps: {
    updateUserOriginalSocialMediaImageUrl: (commit, value) =>
      commit("uploadContents/updateUserOriginalSocialMediaImageUrl", value)
  }
})(SocialMediaImage.name, SocialMediaImage);
